import axiosInstance from './axios-instance';

export const fetchCategories = (userId: string) => axiosInstance.get('categories', { params: { userId }});
